import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import postReducer from './postReducer';
import advantageReducer from './advantageReducer';
import reviewReducer from './reviewReducer';
import carsReducer from './carsReducer';
import tehReducer from './tehReducer';
import logotypesReducer from './logotypesReducer';
import coreReducer from './coreReducer';
import authReducer from './authReducer';
import { LOGOUT_SUCCESS } from '../actions/types';


const appReducer = combineReducers({
    form: formReducer,
    posts: postReducer,
    advantages: advantageReducer,
    reviews: reviewReducer,
    cars: carsReducer,
    teh: tehReducer,
    logotypes: logotypesReducer,
    core: coreReducer,
    auth: authReducer,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_SUCCESS) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;